import {
  SelectItem,
  SelectGroup,
  SelectLabel,
  SelectSeparator,
} from "../ui/select";

export const AssigneeOptions = ({ activeUsers, currentUserId }) => (
  <>
    <SelectItem value="none">--</SelectItem>
    {activeUsers.length > 0 && (
      <SelectGroup>
        <SelectLabel className="text-xs font-semibold text-[var(--t-text-muted)] uppercase tracking-wider">Team</SelectLabel>
        {activeUsers.map((u) => (
          <SelectItem key={u.user_id} value={`coordinator:${u.user_id}`}>
            {u.name}{u.role === "super_admin" ? " (Admin)" : ""}{currentUserId === u.user_id ? " (me)" : ""}
          </SelectItem>
        ))}
      </SelectGroup>
    )}
    <SelectSeparator />
    <SelectGroup>
      <SelectLabel className="text-xs font-semibold text-[var(--t-text-muted)] uppercase tracking-wider">External Parties</SelectLabel>
      <SelectItem value="buyer_agent">Buyer&apos;s Agent</SelectItem>
      <SelectItem value="seller_agent">Seller&apos;s Agent</SelectItem>
      <SelectItem value="buyer">Buyer</SelectItem>
      <SelectItem value="seller">Seller</SelectItem>
      <SelectItem value="lender">Lender</SelectItem>
      <SelectItem value="title_company">Title Company</SelectItem>
    </SelectGroup>
  </>
);
